import { render } from "./UIUXFooter.vue?vue&type=template&id=68934b72"
import script from "./UIUXFooter.vue?vue&type=script&lang=js"
export * from "./UIUXFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__